<template>
    <div>
        <!-- {{changeStatusEditClinician}} -->
        <div v-if="!statusEdit">
            <!-- btn form repeater office -->
            <b-button
                variant="primary"
                class="float-right mb-1"
                style="padding: 8px;"
                @click="addActivity"
                v-if="!statusCreate && !clinicianOrClinicianViewer && !dataSpecialist"
            >
                <feather-icon
                    icon="PlusIcon"
                    size="16"
                />
            </b-button>
            <b-row v-if="!statusCreate && !clinicianOrClinicianViewer">
                <b-col
                    cols="12"
                    md="12"
                    class="d-flex align-items-center justify-content-start mb-1 mb-md-0 pl-0"
                >
                <!-- v-on:keyup="searchClaimsName(clientClaimsName)" -->
                    <b-form-input
                        v-model="clientClaimsName"
                        class="d-inline-block mr-1"
                        placeholder="Client name"
                        v-on:keyup="searchClaimUserName(clientClaimsName)"
                    />
                    <!-- <b-form-select
                        v-model="clientClaimsStatus"
                        inline
                        :options="optionsClaimsClientStatus"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        class="d-inline-block mr-50"
                    /> -->
                    <b-form-select
                        v-model="clientClaimsStatus"
                        inline
                        :options="optionsClaimsClientStatus"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        class="d-inline-block mr-50"
                    />
                </b-col>
            </b-row>
            <h2 class="mb-1" v-if="!statusCreate">{{arrayFiltradoClaimsUser.length}} <span style="font-size: 14px; color: #000;"> results found</span></h2>
            <b-table
                :items="arrayFiltradoClaimsUser"
                :fields="fieldsTable"
                responsive="sm"
                hover
                @row-clicked="onRowSelected"
                v-if="!statusCreate"
                :busy="isBusy"
            >
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="ml-1">Loading...</strong>
                    </div>
                </template>

                <template #cell(clientID)="data">
                    #{{data.item.clientID}}
                </template>
            </b-table>
            
            <div v-if="statusCreate">
                <validation-observer ref="editClinicianRules">
                    <b-form
                        class="px-2"
                    >
                    <!-- {{statusCreate}} -->
                        <b-row cols="12">
                            <b-col md="8">
                                <!-- date month and date year -->
                                <b-row>
                                    <b-col md="12">
                                        <b-form-group
                                            label="Clinician Name"
                                        >
                                            <b-form-input
                                                :value="userData.agency + ' · ' + userData.firstName + ' ' + userData.lastName"
                                                readonly
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="7">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Claim Date Month"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Claim Date Month"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                Claim Date Month <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="claimDateMonth"
                                                    placeholder="Claim Date Month"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsMonths"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <b-col md="5">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Claim Date Year"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Claim Date Year"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                Claim Date Year <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="claimDateYear"
                                                    placeholder="Claim Date Year"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsYears"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                </b-row>
                                <b-col md="12" class="px-0" v-if="programClinician !== 'PGRC - OASAS Program'">
                                    <validation-provider
                                        #default="{ errors }"
                                        name="Client"
                                        rules="required"
                                    >
                                        <b-form-group
                                            label-for="Client"
                                            :state="errors.length > 0 ? false:null"
                                        >
                                        <template v-slot:label>
                                            Client <span class="text-danger">*</span>
                                        </template>
                                            <v-select
                                                v-model="client"
                                                placeholder="Client"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                :options="optionsClient"
                                                label="label"
                                            />
                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                </b-col>

                                <b-row v-if="programClinician === 'PGRC - OASAS Program' || programClinician === 'PGRC - Private Practitioner'">
                                    <b-col md="6">
                                        <b-form-group
                                            label-for="Date Of Birth"
                                        >
                                        <template v-slot:label>
                                            Date Of Birth <span class="text-danger">*</span>
                                        </template>
                                            <validation-provider
                                                #default="{ errors }"
                                                name="Date Of Birth"
                                                rules="required"
                                            >
                                                <date-picker
                                                    v-model="dateOfBirthPGRCOASASProgram"
                                                    placeholder="Select a Date"
                                                    type="date"
                                                    format="MMM DD, Y"
                                                    value-type="MM-DD-YYYY"
                                                    style="max-width: 100% !important; width: 100% !important;"
                                                    :state="errors.length > 0 ? false:null"
                                                ></date-picker>
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Sex at birth"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Sex at birth"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                Sex at birth <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="sexAtBirth"
                                                    placeholder="Sex at birth"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionssexAtBirth"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <b-col md="6">
                                        <b-form-group
                                            label-for="Last 4 SSN"
                                        >
                                        <template v-slot:label>
                                            Last 4 SSN <span class="text-danger">*</span>
                                        </template>
                                            <validation-provider
                                                #default="{ errors }"
                                                name="Last 4 SSN"
                                                rules="required"
                                            >
                                                <b-form-input
                                                    v-model="last4SSN"
                                                    trim
                                                    placeholder="Last 4 SSN"
                                                    :state="errors.length > 0 ? false:null"
                                                />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-form-group
                                            label-for="First Two Letters of Last Name (Birth Name)"
                                        >
                                        <template v-slot:label>
                                            First Two Letters of Last Name (Birth Name) <span class="text-danger">*</span>
                                        </template>
                                            <validation-provider
                                                #default="{ errors }"
                                                name="First Two Letters of Last Name (Birth Name)"
                                                rules="required"
                                            >
                                                <b-form-input
                                                    v-model="firstTwoLettersLastName"
                                                    trim
                                                    placeholder="First Two Letters of Last Name (Birth Name)"
                                                    :state="errors.length > 0 ? false:null"
                                                />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                                <div>
                                    <b-form
                                        ref="formRepeaterSessions"
                                        class="repeater-form"
                                        @submit.prevent="repeateAgain"
                                    >
                                        <b-col cols="12">
                                            <hr>
                                        </b-col>
                                        <!-- Row Loop -->
                                        <b-row
                                            v-for="(item, index) in itemsFormRepeater"
                                            :id="item.id"
                                            :key="item.id"
                                            ref="row"
                                        >
                                            <b-col cols="12">
                                                <h5>Session # {{index + 1}}</h5>
                                            </b-col>
                                            <!-- Date of session -->
                                            <b-col md="6">
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Day of Session"
                                                    rules="required"
                                                >
                                                    <b-form-group
                                                        label-for="Day of Session"
                                                        :state="errors.length > 0 ? false:null"
                                                    >
                                                    <template v-slot:label>
                                                        Day of Session <span class="text-danger">*</span>
                                                    </template>
                                                        <v-select
                                                            v-model="item.dayOfSession"
                                                            placeholder="Day of Session"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsDay"
                                                            class="selectDaySession"
                                                            autocomplete="on"
                                                            @keyup.native="changeClaimDateMonth(item.id)"
                                                            :style="!validFormRepeater && !item.dayOfSession ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                        />
                                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                            <!-- Type of session -->
                                            <b-col md="6">
                                                <span style="display: none !important;">
                                                    {{ typeSession = item.typeOfSession }}
                                                    {{ howConducted = item.howConducted }}
                                                    {{ remoteOption = item.remoteOption }}
                                                    {{ amountCompany = item.amount }}
                                                    {{ amountCopay = item.copayAmount }}
                                                    {{ amountSliding = item.enterAmmountInsuranceCompanyPay  }}
                                                </span>
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Type of Session"
                                                    rules="required"
                                                >
                                                    <b-form-group
                                                        label-for="Type of Session"
                                                        :state="errors.length > 0 ? false:null"
                                                    >
                                                    <template v-slot:label>
                                                        Type of Session <span class="text-danger">*</span>
                                                    </template>
                                                        <v-select
                                                            v-model="item.typeOfSession"
                                                            placeholder="Type of Session"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsTypeOfSession"
                                                            :style="!validFormRepeater && !item.typeOfSession ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                        />
                                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                            <!-- Length of session -->
                                            <b-col md="6">
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Length of Session"
                                                    rules="required"
                                                >
                                                    <b-form-group
                                                        label-for="Length of Session"
                                                        :state="errors.length > 0 ? false:null"
                                                    >
                                                    <template v-slot:label>
                                                        Length of Session <span class="text-danger">*</span>
                                                    </template>
                                                        <v-select
                                                            v-model="item.lengthOfSession"
                                                            placeholder="Length of Session"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsLengthOfSession"
                                                            :style="!validFormRepeater && !item.lengthOfSession ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                        />
                                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                            <!-- How Conducted -->
                                            <b-col md="6">
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="How Conducted"
                                                    rules="required"
                                                >
                                                    <b-form-group
                                                        label-for="How Conducted"
                                                        :state="errors.length > 0 ? false:null"
                                                    >
                                                    <template v-slot:label>
                                                        How Conducted <span class="text-danger">*</span>
                                                    </template>
                                                        <v-select
                                                            v-model="item.howConducted"
                                                            placeholder="How Conducted"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsHowConducted"
                                                            :style="!validFormRepeater && !item.howConducted ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                        />
                                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                            <!-- Remote Option -->
                                            <b-col md="6" v-if="item.howConducted === 'Remote'">
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Remote Option"
                                                    rules="required"
                                                >
                                                    <b-form-group
                                                        label-for="Remote Option"
                                                        :state="errors.length > 0 ? false:null"
                                                    >
                                                    <template v-slot:label>
                                                        Remote Option <span class="text-danger">*</span>
                                                    </template>
                                                        <v-select
                                                            v-model="item.remoteOption"
                                                            placeholder="Remote Option"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsRemoteOption"
                                                            :style="!validFormRepeater && !item.remoteOption ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                        />
                                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                            <!-- Is insurance utilized for session -->
                                            <b-col md="6">
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Is insurance reimbursing for session?"
                                                    rules="required"
                                                >
                                                    <b-form-group
                                                        label-for="Is insurance reimbursing for session?"
                                                        :state="errors.length > 0 ? false:null"
                                                    >
                                                    <template v-slot:label>
                                                        Is insurance reimbursing for session? <span class="text-danger">*</span>
                                                    </template>
                                                        <v-select
                                                            v-model="item.isInsuranceUtilizedForSession"
                                                            placeholder="Is insurance reimbursing for session?"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsIsInsuranceUtilizedForSession"
                                                            :style="!validFormRepeater && !item.isInsuranceUtilizedForSession ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                        />
                                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                            <!-- Options if insurance utilized for claim is: YES -->
                                            <b-col md="6" v-if="item.isInsuranceUtilizedForSession === 'Yes'">
                                                <b-form-group
                                                    label-for="Enter name of insurance company"
                                                >
                                                <template v-slot:label>
                                                    Enter name of insurance company
                                                </template>
                                                    <!-- <validation-provider
                                                        #default="{ errors }"
                                                        name="Enter name of insurance company"
                                                        rules="required"
                                                    > -->
                                                        <b-form-input
                                                            v-model="item.nameOfInsuranceCompany"
                                                            trim
                                                            placeholder="Enter name of insurance company"
                                                            :style="!validFormRepeater && !item.nameOfInsuranceCompany ? 'background: #efefef; background-color: #efefef; cursor: no-drop;' : 'background: #efefef; background-color: #efefef; cursor: no-drop;'"
                                                            :disabled="true"
                                                        />
                                                        <!-- <small class="text-danger">{{ errors[0] }}</small>
                                                    </validation-provider> -->
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="6" v-if="item.isInsuranceUtilizedForSession === 'Yes'">
                                                <b-form-group
                                                    label-for="Enter amount insurance company will pay for session"
                                                >
                                                <template v-slot:label>
                                                    Enter amount insurance company will pay for session
                                                </template>
                                                    <!-- <validation-provider
                                                        #default="{ errors }"
                                                        name="Enter amount insurance company will pay for session"
                                                        rules="required"
                                                    > -->
                                                        <cleave
                                                            v-model="item.enterAmmountInsuranceCompanyPay"
                                                            class="form-control"
                                                            :raw="false"
                                                            :options="options.block"
                                                            placeholder="Enter amount insurance company will pay for session"
                                                            :style="!validFormRepeater && item.enterAmmountInsuranceCompanyPay === '' ? 'background: #efefef; background-color: #efefef; cursor: no-drop;' : 'background: #efefef; background-color: #efefef; cursor: no-drop;'"
                                                            :disabled="true"
                                                        />
                                                        <!-- <small class="text-danger">{{ errors[0] }}</small>
                                                    </validation-provider> -->
                                                </b-form-group>
                                            </b-col>
                                            <!-- Options if insurance utilized for claim is: NO -->
                                            <b-col :md="item.ifNotUtilizingInsuranceSession === 'Other' ? '6' : '6'" v-if="item.isInsuranceUtilizedForSession === 'No'">
                                                <!-- <validation-provider
                                                    #default="{ errors }"
                                                    name="If insurance is not reimbursing, select reason why"
                                                    rules="required"
                                                > -->
                                                    <b-form-group
                                                        label-for="If insurance is not reimbursing, select reason why"
                                                    >
                                                    <template v-slot:label>
                                                        If insurance is not reimbursing, select reason why
                                                    </template>
                                                        <v-select
                                                            v-model="item.ifNotUtilizingInsuranceSession"
                                                            placeholder="If insurance is not reimbursing, select reason why"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsIfNotUtilizingInsurance"
                                                            :style="!validFormRepeater && !item.ifNotUtilizingInsuranceSession ? 'background: #efefef; background-color: #efefef; cursor: no-drop;' : 'background: #efefef; background-color: #efefef; cursor: no-drop;'"
                                                            :disabled="true"
                                                        />
                                                        <!-- <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback> -->
                                                    </b-form-group>
                                                <!-- </validation-provider> -->
                                            </b-col>
                                            <b-col md="6" v-if="item.ifNotUtilizingInsuranceSession === 'Other' && item.isInsuranceUtilizedForSession === 'No'">
                                                <b-form-group
                                                    label-for="If no, please explain"
                                                >
                                                <template v-slot:label>
                                                    If no, please explain
                                                </template>
                                                    <!-- <validation-provider
                                                        #default="{ errors }"
                                                        name="If no, please explain"
                                                        rules="required"
                                                    > -->
                                                        <b-form-input
                                                            v-model="item.ifNotUtilizingInsuranceSessionResponseOther"
                                                            trim
                                                            placeholder="If no, please explain"
                                                            :style="!validFormRepeater && !item.ifNotUtilizingInsuranceSessionResponseOther ? 'background: #efefef; background-color: #efefef; cursor: no-drop;' : 'background: #efefef; background-color: #efefef; cursor: no-drop;'"
                                                            :disabled="true"
                                                        />
                                                        <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                                                    <!-- </validation-provider> -->
                                                </b-form-group>
                                            </b-col>

                                            <b-col :md="item.didClientProvideCopay === 'Yes' ? '6' : '6'">
                                                {{item.isInsuranceUtilizedForSession === 'Yes' ? item.didClientProvideCopay = '' : null}}
                                                <b-form-group
                                                    label-for="Did client provide copay?"
                                                    v-if="item.isInsuranceUtilizedForSession === 'No'"
                                                >
                                                <template v-slot:label>
                                                    Did client provide copay?
                                                </template>
                                                    <v-select
                                                        v-model="item.didClientProvideCopay"
                                                        placeholder="Did client provide copay?"
                                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                        :options="optionsDidClientProvideCopay"
                                                        :disabled="true"
                                                        :style="'background: #efefef; background-color: #efefef; cursor: no-drop;'"
                                                    />
                                                </b-form-group>
                                                <!-- <validation-provider
                                                    #default="{ errors }"
                                                    name="Did client provide copay?"
                                                    rules="required"
                                                    v-else
                                                > -->
                                                    <b-form-group
                                                        label-for="Did client provide copay?"
                                                        v-else
                                                    >
                                                    <template v-slot:label>
                                                        Did client provide copay?
                                                    </template>
                                                        <v-select
                                                            v-model="item.didClientProvideCopay"
                                                            placeholder="Did client provide copay?"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsDidClientProvideCopay"
                                                            :style="!validFormRepeater && !item.didClientProvideCopay ? 'background: #efefef; background-color: #efefef; cursor: no-drop;' : 'background: #efefef; background-color: #efefef; cursor: no-drop;'"
                                                            :disabled="true"
                                                        />
                                                        <!-- <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback> -->
                                                    </b-form-group>
                                                <!-- </validation-provider> -->
                                            </b-col>
                                            <b-col md="6" v-if="item.didClientProvideCopay === 'Yes'">
                                                {{item.isInsuranceUtilizedForSession === 'Yes' ? item.copayAmount = '' : null}}
                                                <b-form-group
                                                    label-for="Copay Amount"
                                                >
                                                <template v-slot:label>
                                                    Copay Amount
                                                </template>
                                                    <!-- <validation-provider
                                                        #default="{ errors }"
                                                        name="Copay Amount"
                                                        rules="required"
                                                    > -->
                                                        <b-form-input
                                                            v-model="item.copayAmount"
                                                            trim
                                                            placeholder="Copay Amount"
                                                            autofocus
                                                            :style="!validFormRepeater && item.copayAmount === '' ? 'background: #efefef; background-color: #efefef; cursor: no-drop;' : item.isInsuranceUtilizedForSession === 'Yes' ? 'background: #efefef; background-color: #efefef; cursor: no-drop;' : 'background: #efefef; background-color: #efefef; cursor: no-drop;'"
                                                            :disabled="true"
                                                        />
                                                        <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                                                    <!-- </validation-provider> -->
                                                </b-form-group>
                                            </b-col>
                                            
                                            <b-col :md="item.didClientUtilizeSlidingScale === 'Yes' ? '6' : '6'">
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Did client utilize sliding scale?"
                                                    rules="required"
                                                >
                                                    <b-form-group
                                                        label-for="Did client utilize sliding scale?"
                                                        :state="errors.length > 0 ? false:null"
                                                    >
                                                    <template v-slot:label>
                                                        Did client utilize sliding scale? <span class="text-danger">*</span>
                                                    </template>
                                                        <v-select
                                                            v-model="item.didClientUtilizeSlidingScale"
                                                            placeholder="Did client utilize sliding scale?"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsDidClientUtilizeSlidingScale"
                                                            :style="!validFormRepeater && !item.didClientUtilizeSlidingScale ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                        />
                                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                            <b-col md="6" v-if="item.didClientUtilizeSlidingScale === 'Yes'">
                                                <b-form-group
                                                    label-for="Amount"
                                                >
                                                <template v-slot:label>
                                                    Amount <span class="text-danger">*</span>
                                                </template>
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Amount"
                                                        rules="required"
                                                    >
                                                        <b-form-input
                                                            v-model="item.amount"
                                                            trim
                                                            :state="errors.length > 0 ? false:null"
                                                            placeholder="Amount"
                                                            autofocus
                                                            :style="!validFormRepeater && item.amount === '' ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                        />
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>

                                            <!-- Subtotal billed to PGRC -->
                                            <span style="display: none">
                                                {{ item.didClientUtilizeSlidingScale === 'No' ? item.amount = 0 : null }}

                                                {{ item.isInsuranceUtilizedForSession === 'Yes' ? item.subtotalBilledToPGRC = '$'+(0).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '15 minutes' ? item.subtotalBilledToPGRC = '$'+((group15Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '30 minutes' ? item.subtotalBilledToPGRC = '$'+((group30Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '45 minutes' ? item.subtotalBilledToPGRC = '$'+((group45Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '60 minutes' ? item.subtotalBilledToPGRC = '$'+((group60Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '75 minutes' ? item.subtotalBilledToPGRC = '$'+((group75Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '90 minutes' ? item.subtotalBilledToPGRC = '$'+((group90Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '15 minutes' ? item.subtotalBilledToPGRC = '$'+((individual15Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '30 minutes' ? item.subtotalBilledToPGRC = '$'+((individual30Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '45 minutes' ? item.subtotalBilledToPGRC = '$'+((individual45Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '60 minutes' ? item.subtotalBilledToPGRC = '$'+((individual60Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '75 minutes' ? item.subtotalBilledToPGRC = '$'+((individual75Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '90 minutes' ? item.subtotalBilledToPGRC = '$'+((individual90Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.subtotalBilledToPGRC = '$'+(0).toFixed(2) }}

                                                {{ item.isInsuranceUtilizedForSession === 'Yes' ? subtotalPGRCobserver = '$'+(0).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '15 minutes' ? subtotalPGRCobserver = '$'+((group15Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '30 minutes' ? subtotalPGRCobserver = '$'+((group30Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '45 minutes' ? subtotalPGRCobserver = '$'+((group45Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '60 minutes' ? subtotalPGRCobserver = '$'+((group60Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '75 minutes' ? subtotalPGRCobserver = '$'+((group75Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '90 minutes' ? subtotalPGRCobserver = '$'+((group90Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '15 minutes' ? subtotalPGRCobserver = '$'+((individual15Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '30 minutes' ? subtotalPGRCobserver = '$'+((individual30Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '45 minutes' ? subtotalPGRCobserver = '$'+((individual45Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '60 minutes' ? subtotalPGRCobserver = '$'+((individual60Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '75 minutes' ? subtotalPGRCobserver = '$'+((individual75Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '90 minutes' ? subtotalPGRCobserver = '$'+((individual90Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : subtotalPGRCobserver = '$'+(0).toFixed(2) }}

                                                {{ item.subtotalBilledToPGRC ? calculateAmountBilledToCFE() : null }}
                                            </span>
                                            <b-col md="6">
                                                <b-form-group
                                                    label="Subtotal billed to PGRC"
                                                    label-for="Subtotal billed to PGRC"
                                                >
                                                    <b-form-input
                                                        v-model="item.subtotalBilledToPGRC"
                                                        trim
                                                        placeholder="Subtotal billed to PGRC"
                                                        readonly
                                                    />
                                                </b-form-group>
                                            </b-col>

                                            <!-- Remove Button -->
                                            <b-col
                                                cols="12"
                                                class="mb-1"
                                            >
                                                <b-button
                                                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                                    variant="outline-danger"
                                                    class="mt-0 mt-md-2"
                                                    @click="removeItem(index)"
                                                >
                                                    <feather-icon
                                                        icon="XIcon"
                                                        class="mr-25"
                                                    />
                                                    <span>Delete</span>
                                                </b-button>
                                            </b-col>
                                            <b-col cols="12">
                                                <hr>
                                            </b-col>
                                        </b-row>
                                    </b-form>
                                </div>
                                <!-- add session button -->
                                <b-button
                                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                    variant="outline-primary"
                                    class="mb-1 p-50"
                                    @click="repeateAgain"
                                >
                                    <feather-icon
                                        icon="PlusIcon"
                                        class="mr-50"
                                    />
                                    <span class="align-middle">Add Session</span>
                                </b-button>
                                
                                <b-col md="12" class="px-0">
                                    <validation-provider
                                        #default="{ errors }"
                                        name="Client Progress This Month"
                                        rules="required"
                                    >
                                        <b-form-group
                                            label-for="Client Progress This Month"
                                            :state="errors.length > 0 ? false:null"
                                        >
                                        <template v-slot:label>
                                            Client Progress This Month <span class="text-danger">*</span>
                                        </template>
                                            <v-select
                                                v-model="clientProgressThisMonth"
                                                placeholder="Client Progress This Month"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                :options="optionsClientProgressThisMonth"
                                            />
                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                </b-col>
                                <b-col md="12" class="px-0">
                                    <b-form-group
                                        label="Amount Billed to PGRC"
                                    >
                                        <b-form-input
                                            v-model="amountBilledToCFE"
                                            trim
                                            placeholder="Amount Billed to PGRC"
                                            readonly
                                        />
                                    </b-form-group>
                                </b-col>
                            </b-col>

                            <!-- RIGHT CONTENT -->
                            <b-col md="4">
                                <b-form-group
                                    label="Notes"
                                >
                                    <b-form-textarea
                                        id="textarea-default"
                                        placeholder="Notes"
                                        rows="3"
                                        v-model="notes"
                                    />
                                </b-form-group>

                                <b-row class="mt-3">
                                    <b-col md="4">
                                        <b-form-group
                                            label-for="# of Individual In-Person Sessions"
                                        >
                                        <template v-slot:label>
                                            # of Individual In-Person Sessions
                                        </template>
                                            <validation-provider
                                                #default="{ errors }"
                                                name="# of Individual In-Person Sessions"
                                                rules="required"
                                            >
                                                <cleave
                                                    v-model="noIndividualSessions"
                                                    class="form-control"
                                                    :raw="false"
                                                    :options="options.block"
                                                    placeholder="# of Individual In-Person Sessions"
                                                    :state="errors.length > 0 ? false:null"
                                                    readonly
                                                />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="4">
                                        <b-form-group
                                            label-for="# of Group Sessions"
                                        >
                                        <template v-slot:label>
                                            # of Group Sessions
                                        </template>
                                            <validation-provider
                                                #default="{ errors }"
                                                name="# of Group Sessions"
                                                rules="required"
                                            >
                                                <cleave
                                                    v-model="noGroupSessions"
                                                    class="form-control"
                                                    :raw="false"
                                                    :options="options.block"
                                                    placeholder="# of Group Sessions"
                                                    :state="errors.length > 0 ? false:null"
                                                    readonly
                                                />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="4">
                                        <b-form-group
                                            label-for="# of Remote Sessions"
                                        >
                                        <template v-slot:label>
                                            # of Remote Sessions
                                        </template>
                                            <validation-provider
                                                #default="{ errors }"
                                                name="# of Remote Sessions"
                                                rules="required"
                                            >
                                                <cleave
                                                    v-model="noRemoteSessions"
                                                    class="form-control"
                                                    :raw="false"
                                                    :options="options.block"
                                                    placeholder="# of Remote Sessions"
                                                    :state="errors.length > 0 ? false:null"
                                                    readonly
                                                />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col md="4">
                                        <b-form-group
                                            label-for="# of Assessment Sessions"
                                        >
                                        <template v-slot:label>
                                            # of Assessment Sessions
                                        </template>
                                            <validation-provider
                                                #default="{ errors }"
                                                name="# of Assessment Sessions"
                                                rules="required"
                                            >
                                                <cleave
                                                    v-model="noAssessmentSessions"
                                                    class="form-control"
                                                    :raw="false"
                                                    :options="options.block"
                                                    placeholder="# of Assessment Sessions"
                                                    :state="errors.length > 0 ? false:null"
                                                    readonly
                                                />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="4">
                                        <b-form-group
                                            label-for="# of Couple Sessions"
                                        >
                                        <template v-slot:label>
                                            # of Couple Sessions
                                        </template>
                                            <validation-provider
                                                #default="{ errors }"
                                                name="# of Couple Sessions"
                                                rules="required"
                                            >
                                                <cleave
                                                    v-model="noCoupleSessions"
                                                    class="form-control"
                                                    :raw="false"
                                                    :options="options.block"
                                                    placeholder="# of Couple Sessions"
                                                    :state="errors.length > 0 ? false:null"
                                                    readonly
                                                />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="4">
                                        <b-form-group
                                            label-for="# of Family Sessions"
                                        >
                                        <template v-slot:label>
                                            # of Family Sessions
                                        </template>
                                            <validation-provider
                                                #default="{ errors }"
                                                name="# of Family Sessions"
                                                rules="required"
                                            >
                                                <cleave
                                                    v-model="noFamilySessions"
                                                    class="form-control"
                                                    :raw="false"
                                                    :options="options.block"
                                                    placeholder="# of Family Sessions"
                                                    :state="errors.length > 0 ? false:null"
                                                    readonly
                                                />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <!-- Form Actions -->
                        <div class="d-flex mt-2 float-right">
                            <b-button
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                variant="flat-primary"
                                @click="statusCreate = false"
                            >
                            Back to list
                            </b-button>
                            <b-button
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="primary"
                                class="mr-2"
                                type="submit"
                                @click.prevent="validationForm"
                            >
                            Save
                            </b-button>
                        </div>
                    </b-form>
                </validation-observer>
            </div>
        </div>

        <div v-else>
            <edit-client-claim :idClientClaim="idClientClaim" @statusEditClientClaim="statusEdit = $event"/>
        </div>

        <!-- POP UP # of remote sesions -->
        <b-modal
            cancel-variant="outline-secondary"
            centered
            ref="modal-RemoteSessions"
            title="Remote Sessions"
            @ok="validationFormRemoteSesions"
            :hideHeaderClose="true"
            :no-close-on-backdrop="true"
            :close-on-backdrop="false"
            :close-on-esc="false"
            ok-only
        >
            <b-alert
                variant="danger"
                show
                v-if="msgRemoteSessions"
            >
                <div class="alert-body">
                    <span>{{ msgRemoteSessions }}</span>
                </div>
            </b-alert>
            <h6 class="mb-1"><span style="font-size: 14px; color: #000;">Total Remote Sessions: </span>{{noRemoteSessions}}</h6>
            <validation-observer ref="editRemoteSesionsRules">
                <b-form>
                    <b-form-group
                        label-for="# of Remote Sessions"
                    >
                    <template v-slot:label>
                        # of Remote Sessions <span class="text-danger">*</span>
                    </template>
                        <validation-provider
                            #default="{ errors }"
                            name="# of Remote Sessions"
                            rules="required"
                        >
                            <cleave
                                v-model="noRemoteSessions"
                                class="form-control"
                                :raw="false"
                                :options="options.block"
                                placeholder="# of Remote Sessions"
                                :state="errors.length > 0 ? false:null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group
                        label-for="# of Phone Sessions"
                    >
                    <template v-slot:label>
                        # of Phone Sessions <span class="text-danger">*</span>
                    </template>
                        <validation-provider
                            #default="{ errors }"
                            name="# of Phone Sessions"
                            rules="required"
                        >
                            <cleave
                                v-model="noPhoneSessions"
                                class="form-control"
                                :raw="false"
                                :options="options.block"
                                placeholder="# of Phone Sessions"
                                :state="errors.length > 0 ? false:null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group
                        label-for="# of Video Sessions"
                    >
                    <template v-slot:label>
                        # of Video Sessions <span class="text-danger">*</span>
                    </template>
                        <validation-provider
                            #default="{ errors }"
                            name="# of Video Sessions"
                            rules="required"
                        >
                            <cleave
                                v-model="noVideoSessions"
                                class="form-control"
                                :raw="false"
                                :options="options.block"
                                placeholder="# of Video Sessions"
                                :state="errors.length > 0 ? false:null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-form>
            </validation-observer>
        </b-modal>
    </div>
</template>

<script>
import { 
    BForm, BButton, BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BTable, BFormInvalidFeedback, BModal, VBModal, BAlert, BFormSelect,
    BSpinner,
} from 'bootstrap-vue'
import EditClientClaim from './components/EditClientClaim.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { heightTransition } from '@core/mixins/ui/transition'
import flatPickr from 'vue-flatpickr-component'
import { required, email } from '@validations'
import Cleave from 'vue-cleave-component'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import { db, auth } from '@/firebase'
import moment from 'moment'
import parse from 'uuid/dist/parse'

export default {
    data() {
        return {
            // validation
            required,
            email,
            options: {
                block: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'false',
                    delimiter: ''
                },
            },
            userData: '',
            userLoggedData: '',
            isClinician: false,
            clinicianOrClinicianViewer: false,
            dataSpecialist: false,
            adminOrManageUsers: false,
            isAdmin: false,
            msgRemoteSessions: '',
            statusEditClinician: false,
            idClinicianDependency: '',
            programClinician: '',

            // filters
            clientClaimsName: '',
            clientClaimsStatus: null,
            optionsClaimsClientStatus: [
                {value: null, text: 'Approval status'},
                {value: 'paid', text: 'Paid'},
                {value: 'approved', text: 'Approved'},
                {value: 'denied', text: 'Denied'},
                {value: 'pending dm approval', text: 'Pending DM Approval'},
                {value: 'pending pm approval', text: 'Pending PM Approval'},
            ],
            
            // view edit
            statusEdit: false,
            idClientClaim: '',

            // settings table and edit view
            statusCreate: false,
            itemsClaims: [],
            fieldsTable: [
                { key: 'clientID', sortable: false },
                { key: 'clientName', sortable: false },
                { key: 'approvalStatus', sortable: false },
                { key: 'claimDate', sortable: false },
                { key: 'submittedBy', sortable: false },
            ],

            // form
            approvalStatus: 'pending pm approval',
            claimDateMonth: '',
            claimDateYear: '',
            client: '',
            dateOfBirthPGRCOASASProgram: null,
            sexAtBirth: '',
            last4SSN: '',
            firstTwoLettersLastName: '',
            noIndividualSessions: null,
            noGroupSessions: null,
            noRemoteSessions: null,
            noPhoneSessions: null,
            noVideoSessions: null,
            noAssessmentSessions: null,
            noCoupleSessions: null,
            noFamilySessions: null,
            clientInsurance: '',
            isInsuranceUtilizedForClaim: '',
            // isInsuranceUtilizedForClaim: YES
            insuranceReimbursementRateForIndividualSessions: null,
            insuranceReimbursementRateForGroupSessions: null,
            insuranceReimbursementRateForRemoteSessions: null,
            // isInsuranceUtilizedForClaim: No
            ifNotUtilizingInsurance: '',
            // isInsuranceUtilizedForClaim: Other
            ifNotUtilizingInsuranceResponseOther: '',
            clientProgressThisMonth: '',
            clientReportsSatisfactionWithTreatmentSessions: '',
            // clientReportsSatisfactionWithTreatmentSessions: No
            ifNoReportsSatisfaction: '',
            didClientProvideCopay: '',
            copayAmount: '',
            didClientUtilizeSlidingScale: '',
            amount: '',
            amountBilledToCFE: '$0.00',
            notes: '',

            // get data from db
            optionsClient: [],
            optionsClinician: [],

            optionssexAtBirth: [
                'Male',
                'Female'
            ],
            optionsDay: [
                '01', '02', '03', '04', '05',
                '06', '07', '08', '09', '10',
                '11', '12', '13', '14', '15',
                '16', '17', '18', '19', '20',
                '21', '22', '23', '24', '25',
                '26', '27', '28', '29', '30',
                '31',
            ],
            optionsMonths: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            optionsYears: [],
            optionsInsuranceType: [],
            optionsIsInsuranceUtilizedForClaim: ['Yes', 'No'],
            optionsIfNotUtilizingInsurance: [
                "Client doesn't have insurance",
                'Deductible not met',
                "Don't accept client's insurance",
                'Insurance does not cover telehealth services',
                'Other'
            ],
            optionsClientProgressThisMonth: ['N/A','Declined','Improved','No Change'],
            optionsClientReportsSatisfactionWithTreatmentSessions: ['Yes', 'No'],
            optionsDidClientProvideCopay: ['Yes', 'No'],
            optionsDidClientUtilizeSlidingScale: ['Yes', 'No'],

            // formRepeater Sessions
            itemsFormRepeater: [],
            nextTodoId: 1,
            optionsTypeOfSession: [
                'Assessment',
                'Individual',
                'Couple',
                'Family',
                'Group'
            ],
            optionsLengthOfSession: [
                '15 minutes',
                '30 minutes',
                '45 minutes',
                '60 minutes',
                '75 minutes',
                '90 minutes'
            ],
            optionsHowConducted: [
                'In-person',
                'Remote'
            ],
            optionsRemoteOption: ['Video','Phone'],
            optionsIsInsuranceUtilizedForSession: ['Yes','No'],
            optionsIsClientProvidingPaymentForSession: ['Yes','No'],
            ammountRegionCalculated1: 0,
            ammountRegionCalculated2: 0,
            individual15Min: 0,
            individual30Min: 0,
            individual45Min: 0,
            individual60Min: 0,
            individual75Min: 0,
            individual90Min: 0, 
            group15Min: 0,
            group30Min: 0,
            group45Min: 0,
            group60Min: 0,
            group75Min: 0,
            group90Min: 0,

            // session observer
            typeSession: '',
            howConducted: '',
            remoteOption: '',
            amountCompany: '',
            amountCopay: '',
            amountSliding: '',
            subtotalPGRCobserver: 0,
            subtotalPGRC: 0,

            // overlay
            isBusy: true,
            validFormRepeater: true,
        }
    },
    components: {
        BForm,
        BButton,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormTextarea,
        BTable,
        BFormInvalidFeedback,
        BModal,
        BAlert,
        BFormSelect,
        BSpinner,
        Cleave,
        
        // select
        vSelect,

        // date
        flatPickr,
        DatePicker,

        // Form Validation
        ValidationProvider,
        ValidationObserver,

        // edit claim
        EditClientClaim,
    },
    directives: {
        'b-modal': VBModal,
        Ripple,
    },
    mixins: [heightTransition],
    computed: {
        ...mapGetters(['arrayFiltradoClaimsUser']),
        ...mapState(['usuario'])
    },
    props: ['changeStatusEditClinician'],
    watch: {
        // clientClaimsName(val) {
        //     console.log(val)
        // },
        typeSession(val) {
            this.counterSession()
        },
        howConducted(val) {
            this.counterSession()
        },
        remoteOption(val) {
            this.counterSession()
        },
        amountCompany(val) {
            this.counterSession()
        },
        amountCopay(val) {
            this.counterSession()
        },
        amountSliding(val) {
            this.counterSession()
        },
        subtotalPGRCobserver(val) {
            // console.log(val)
            this.amountSession()
        },
        clientClaimsStatus(val) {
            this.searchClaimUserStatus(val)
        },
        noRemoteSessions(val) {
            var noRemoteSessionsAtomic =  parseInt(val, 10)
            if(noRemoteSessionsAtomic >= 1) {
                // setTimeout(() => {
                //     this.$refs['modal-RemoteSessions'].show()
                //     // console.log(noRemoteSessionsAtomic)
                // }, 1000)
            } else if(noRemoteSessionsAtomic === 0) {
                this.noPhoneSessions = 0
                this.noVideoSessions = 0
            }

            this.calculateAmountBilledToCFE()
        },
        isInsuranceUtilizedForClaim(val) {
            if(val === 'Yes') {
                this.calculateAmountBilledToCFE()
            } else {
                this.insuranceReimbursementRateForIndividualSessions = 0
                this.insuranceReimbursementRateForGroupSessions = 0
                this.insuranceReimbursementRateForRemoteSessions = 0
            }
        },
        insuranceReimbursementRateForIndividualSessions() {
            this.calculateAmountBilledToCFE()
        },
        insuranceReimbursementRateForGroupSessions() {
            this.calculateAmountBilledToCFE()
        },
        insuranceReimbursementRateForRemoteSessions() {
            this.calculateAmountBilledToCFE()
        },
        noIndividualSessions() {
            this.calculateAmountBilledToCFE()
        },
        noGroupSessions() {
            this.calculateAmountBilledToCFE()
        },
        statusEdit(val) {
            if(val) {
                this.statusEditClinician = true
                this.$emit('statusEditClinician',true)
                this.counterSession()
            } else {
                this.statusEditClinician = false
                this.$emit('statusEditClinician',false)
            }
        },
        statusCreate(val) {
            if(val) {
                // this.statusEditClinician = true
                this.$emit('statusEditClinician',true)
                this.counterSession()
            } else {
                // this.statusEditClinician = false
                this.$emit('statusEditClinician',false)
            }
        },
        changeStatusEditClinician(val) {
            if(val) {
                if(this.statusCreate) {
                    this.statusCreate = true
                } else {
                    this.statusEditClinician = true
                    this.statusEdit = true
                    this.$emit('statusEditClinician',true)
                }
            } else {
                this.statusEditClinician = false
                this.statusEdit = false
                this.statusCreate = false
                this.$emit('statusEditClinician',false)
            }
        },
        client(val) {
            // console.log(val,val?.dateOfBirth ? val?.dateOfBirth : '')
            if(val) {
                this.dateOfBirthPGRCOASASProgram = val?.dateOfBirth ? val?.dateOfBirth : ''
                this.sexAtBirth = val?.sexAtBirth ? val?.sexAtBirth : ''
                this.last4SSN = val?.last4ofSSN ? val?.last4ofSSN : ''
                this.firstTwoLettersLastName = val?.firstTwoLettersLastName ? val?.firstTwoLettersLastName : ''
            }
        }
    },
    methods: {
        ...mapActions(['createClientClaim','setSnapshotClaimsUser','searchClaimUserName','searchClaimUserStatus']),
        changeClaimDateMonth(val) {
            // console.log('id: ',val)
            // console.log(this.$refs.myInput.value,document.getElementsByClassName('vs__search'))
            document.getElementsByClassName('vs__search').forEach(ele => {
                // console.log(ele.autocomplete, ele.value)
                if(ele.autocomplete === 'on' || ele.placeholder === 'Day of Session') {
                    // console.log(ele)
                    // console.log('keypress 1: ',ele.value)
                    var filterRepeter = this.itemsFormRepeater.filter(item => item.id === val)
                    if(filterRepeter.length >= 1) {
                        filterRepeter.forEach(eleItem => {
                            if(ele.value === '1' || ele.value === '01') {
                                eleItem.dayOfSession = '01'
                            } else if(ele.value === '2' || ele.value === '02') {
                                eleItem.dayOfSession = '02'
                            } else if(ele.value === '3' || ele.value === '03') {
                                eleItem.dayOfSession = '03'
                            } else if(ele.value === '4' || ele.value === '04') {
                                eleItem.dayOfSession = '04'
                            } else if(ele.value === '5' || ele.value === '05') {
                                eleItem.dayOfSession = '05'
                            } else if(ele.value === '6' || ele.value === '06') {
                                eleItem.dayOfSession = '06'
                            } else if(ele.value === '7' || ele.value === '07') {
                                eleItem.dayOfSession = '07'
                            } else if(ele.value === '8' || ele.value === '08') {
                                eleItem.dayOfSession = '08'
                            } else if(ele.value === '9' || ele.value === '09') {
                                eleItem.dayOfSession = '09'
                            } else {
                                var validDayValue = parseInt(ele.value, 10)
                                if(validDayValue && validDayValue <= 31) {
                                    eleItem.dayOfSession = validDayValue.toString()
                                }
                            }
                        })
                        // console.log('keypress 2: ',ele.value)
                    }
                }
            })
        },
        amountSession() {
            this.subtotalPGRC = 0
            
            if(this.itemsFormRepeater.length >= 1) {
                this.itemsFormRepeater.forEach(item => {
                    // console.log(item.subtotalBilledToPGRC.replace(/[$]/g, ''))
                    if(item.subtotalBilledToPGRC) {
                        var atomSubtotal = item.subtotalBilledToPGRC.replace(/[$]/g, '')
                        this.subtotalPGRC += parseFloat(atomSubtotal)
                        // console.log(this.subtotalPGRC)
                    }
                })
                this.counterSession()
            }
        },
        counterSession() {
            this.noIndividualSessions = 0
            this.noGroupSessions = 0
            this.noRemoteSessions = 0
            this.noAssessmentSessions = 0
            this.noCoupleSessions = 0
            this.noFamilySessions = 0
            this.noPhoneSessions = 0
            this.noVideoSessions = 0

            // typeOfSession
            if(this.itemsFormRepeater.length >= 1) {
                this.itemsFormRepeater.forEach(item => {
                    if(item.typeOfSession === 'Assessment') {
                        this.noAssessmentSessions += 1
                    } else if(item.typeOfSession === 'Individual') {
                        if(item.howConducted === 'Remote') {
                            this.noRemoteSessions += 1

                            if(item.remoteOption === 'Phone') {
                                this.noPhoneSessions += 1
                            } else if(item.remoteOption === 'Video') {
                                this.noVideoSessions += 1
                            }
                        } else if(item.howConducted === 'In-person') {
                            this.noIndividualSessions += 1
                        } else {
                            this.noIndividualSessions += 1
                        }
                    } else if(item.typeOfSession === 'Couple') {
                        this.noCoupleSessions += 1
                    } else if(item.typeOfSession === 'Family') {
                        this.noFamilySessions += 1
                    } else if(item.typeOfSession === 'Group') {
                        this.noGroupSessions += 1
                    } else if(item.typeOfSession === 'Remote') {
                        this.noRemoteSessions += 1
                    }

                    item.amount ? item.amount = parseFloat(item.amount) : item.amount= 0
                    item.copayAmount ? item.copayAmount = parseFloat(item.copayAmount) : item.copayAmount = 0
                    // item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay = parseFloat(item.enterAmmountInsuranceCompanyPay) : item.enterAmmountInsuranceCompanyPay = 0

                    // this.subtotalPGRCobserver -= item.amount
                    // this.subtotalPGRCobserver -= item.copayAmount
                    // this.subtotalPGRCobserver -= item.enterAmmountInsuranceCompanyPay
                    // console.log(item.amount,item.copayAmount,item.enterAmmountInsuranceCompanyPay,this.subtotalPGRCobserver)

                    // if(item.subtotalBilledToPGRC) {
                    //     var atomSubtotal = item.subtotalBilledToPGRC.replace(/[$]/g, '')
                    //     this.subtotalPGRC += parseFloat(atomSubtotal)
                    // }
                    // this.amountSession()
                })
            }
        },
        addActivity() {
            this.statusCreate = true
        },
        calculateAmountBilledToCFE() {
            // var RegionRate = 0.00
            // var GroupRegionRate = 0.00
            // var RemoteRegionRate = 0.00
            // if(this.userData.region.toLowerCase() === 'western') {
            //     RegionRate = 80.00
            //     GroupRegionRate = 80.00
            //     RemoteRegionRate = 80.00
            // } else if(this.userData.region.toLowerCase() === 'finger lakes') {
            //     RegionRate = 80.00
            //     GroupRegionRate = 80.00
            //     RemoteRegionRate = 80.00
            // } else if(this.userData.region.toLowerCase() === 'central') {
            //     RegionRate = 80.00
            //     GroupRegionRate = 80.00
            //     RemoteRegionRate = 80.00
            // } else if(this.userData.region.toLowerCase() === 'northeast') {
            //     RegionRate = 80.00
            //     GroupRegionRate = 80.00
            //     RemoteRegionRate = 80.00
            // } else if(this.userData.region.toLowerCase() === 'mid-hudson') {
            //     RegionRate = 90.00
            //     GroupRegionRate = 90.00
            //     RemoteRegionRate = 90.00
            // } else if(this.userData.region.toLowerCase() === 'bronx') {
            //     RegionRate = 90.00
            //     GroupRegionRate = 90.00
            //     RemoteRegionRate = 90.00
            // } else if(this.userData.region.toLowerCase() === 'brooklyn') {
            //     RegionRate = 90.00
            //     GroupRegionRate = 90.00
            //     RemoteRegionRate = 90.00
            // } else if(this.userData.region.toLowerCase() === 'manhattan') {
            //     RegionRate = 90.00
            //     GroupRegionRate = 90.00
            //     RemoteRegionRate = 90.00
            // } else if(this.userData.region.toLowerCase() === 'queens') {
            //     RegionRate = 90.00
            //     GroupRegionRate = 90.00
            //     RemoteRegionRate = 90.00
            // } else if(this.userData.region.toLowerCase() === 'staten island') {
            //     RegionRate = 90.00
            //     GroupRegionRate = 90.00
            //     RemoteRegionRate = 90.00
            // } else if(this.userData.region.toLowerCase() === 'long island') {
            //     RegionRate = 90.00
            //     GroupRegionRate = 90.00
            //     RemoteRegionRate = 90.00
            // }

            // var regionRate = this.userData.region ? RegionRate : RegionRate;
            // var groupRegionRate = this.userData.region ? GroupRegionRate : GroupRegionRate;
            // var remoteRegionRate = this.userData.region ? RemoteRegionRate : RemoteRegionRate;

            // if(!this.noIndividualSessions) this.noIndividualSessions = 0
            // if(!this.insuranceReimbursementRateForIndividualSessions) this.insuranceReimbursementRateForIndividualSessions = 0
            // if(!this.noRemoteSessions) this.noRemoteSessions = 0
            // if(!this.insuranceReimbursementRateForRemoteSessions) this.insuranceReimbursementRateForRemoteSessions = 0
            // if(!this.noGroupSessions) this.noGroupSessions = 0
            // if(!this.insuranceReimbursementRateForGroupSessions) this.insuranceReimbursementRateForGroupSessions = 0
            
            // var individualSessionsCost = parseFloat(this.noIndividualSessions) > 0 ? parseFloat(this.noIndividualSessions)*(regionRate - parseFloat(this.insuranceReimbursementRateForIndividualSessions)) : 0;
            // var remoteSessionsCost = parseFloat(this.noRemoteSessions) > 0 ? parseFloat(this.noRemoteSessions) * (remoteRegionRate - parseFloat(this.insuranceReimbursementRateForRemoteSessions)) : 0;
            // var groupSessionsCost = parseFloat(this.noGroupSessions) > 0 ? parseFloat(this.noGroupSessions) * ((groupRegionRate / 2) - parseFloat(this.insuranceReimbursementRateForGroupSessions)) : 0;

            // var resultAmountBilledToCFE = individualSessionsCost + remoteSessionsCost + groupSessionsCost;
            // var resultAmountBilledToCFESum = parseInt(resultAmountBilledToCFE, 10) + parseInt(this.subtotalPGRC, 10)
            // console.log(individualSessionsCost,remoteSessionsCost,groupSessionsCost,resultAmountBilledToCFE);
            var resultAmountBilledToCFESum = 0
            if(this.itemsFormRepeater.length >= 1) {
                this.itemsFormRepeater.forEach(item => {
                    // console.log(item.subtotalBilledToPGRC)
                    resultAmountBilledToCFESum += item.subtotalBilledToPGRC.includes('$') ? parseFloat(item.subtotalBilledToPGRC.substring(1)) : parseFloast(item.subtotalBilledToPGRC)
                })
            }
            this.amountBilledToCFE = '$' + resultAmountBilledToCFESum
        },
        submitFormClientClaim() {
            var claimDateFormat = '01/'+moment().month(this.claimDateMonth).format("MM")+ '/' + this.claimDateYear
            var dateCheck = claimDateFormat.split("/")
            var check = new Date(dateCheck[2], parseInt(dateCheck[1])-1, dateCheck[0])

            var idOASASProgram = ''
            if(this.programClinician === 'PGRC - OASAS Program') {
                if(this.dateOfBirthPGRCOASASProgram && this.firstTwoLettersLastName) {
                    var idClaimOASAS = this.dateOfBirthPGRCOASASProgram.replace(/-/g, '') + this.firstTwoLettersLastName
                    idOASASProgram = idClaimOASAS
                }
            }

            var objClient = {
                idOASASProgram: idOASASProgram ? idOASASProgram : '',
                
                // data update filter
                clientID: this.programClinician === 'PGRC - OASAS Program' ? '' : this.client.clientID,
                clientName: this.programClinician === 'PGRC - OASAS Program' ? '' : this.client.firstName + ' ' + this.client.lastName,
                clientStatus: this.programClinician === 'PGRC - OASAS Program' ? '' : this.client.status,
                languageClient: this.programClinician === 'PGRC - OASAS Program' ? '' : this.client.primaryLanguage,
                regionClient: this.programClinician === 'PGRC - OASAS Program' ? '' : this.client.countryOfResidence,
                clinicianID: this.userData.codigo,
                clinicianName: this.userData.firstName + ' ' + this.userData.lastName,
                region: this.userData.region,
                regionBorough: this.userData.borough ? this.userData.borough : '',
                statusClinician: this.userData.statusReferral ? this.userData.statusReferral : '',
                clinicianProgram: this.userData.program ? this.userData.program : '',
                createdByName: this.userLoggedData.firstName + ' ' + this.userLoggedData.lastName,
                createdByEmail: this.userLoggedData.email,
                createdBy: this.userLoggedData.id,

                // form
                clinician: this.idClinicianDependency,
                approvalStatus: this.approvalStatus,
                claimDateMonth: this.claimDateMonth,
                claimDateYear: this.claimDateYear,
                noIndividualSessions: this.noIndividualSessions,
                noGroupSessions: this.noGroupSessions,
                noRemoteSessions: this.noRemoteSessions,
                noPhoneSessions: this.noPhoneSessions,
                noVideoSessions: this.noVideoSessions,
                noAssessmentSessions: this.noAssessmentSessions,
                noCoupleSessions: this.noCoupleSessions,
                noFamilySessions: this.noFamilySessions,
                clientInsurance: this.clientInsurance,
                isInsuranceUtilizedForClaim: this.isInsuranceUtilizedForClaim,
                // isInsuranceUtilizedForClaim: YES
                insuranceReimbursementRateForIndividualSessions: this.insuranceReimbursementRateForIndividualSessions,
                insuranceReimbursementRateForGroupSessions: this.insuranceReimbursementRateForGroupSessions,
                insuranceReimbursementRateForRemoteSessions: this.insuranceReimbursementRateForRemoteSessions,
                // isInsuranceUtilizedForClaim: No
                ifNotUtilizingInsurance: this.ifNotUtilizingInsurance,
                // ifNotUtilizingInsurance: Other
                ifNotUtilizingInsuranceResponseOther: this.ifNotUtilizingInsuranceResponseOther,
                clientProgressThisMonth: this.clientProgressThisMonth,
                clientReportsSatisfactionWithTreatmentSessions: this.clientReportsSatisfactionWithTreatmentSessions,
                // clientReportsSatisfactionWithTreatmentSessions: No
                ifNoReportsSatisfaction: this.ifNoReportsSatisfaction,
                didClientProvideCopay: this.didClientProvideCopay,
                copayAmount: this.copayAmount,
                didClientUtilizeSlidingScale: this.didClientUtilizeSlidingScale,
                amount: this.amount,
                amountBilledToCFE: this.amountBilledToCFE,
                notes: this.notes,
                client: this.programClinician === 'PGRC - OASAS Program' ? '' : this.client.id,
                dateOfBirthPGRCOASASProgram: this.dateOfBirthPGRCOASASProgram,
                sexAtBirth: this.sexAtBirth,
                last4SSN: this.last4SSN,
                firstTwoLettersLastName: this.firstTwoLettersLastName,
                itemsFormRepeater: this.itemsFormRepeater,
                created: Date.now(),
                status: 'active',

                claimDate: this.claimDateYear + '/' + moment().month(this.claimDateMonth).format("MM") + '/01 00:00:00',
                claimStamp: check,
                claimTime: this.claimDateYear + '-' + moment().month(this.claimDateMonth).format("MM") + '-01 00:00:00',
            }
            // snapshot clinician
            db.collection('usuarios').doc(this.idClinicianDependency).update({
                updated: Date.now()
            })

            this.createClientClaim(objClient)
            this.statusCreate = false
            // reset form
            this.approvalStatus = 'pending pm approval'
            this.claimDateMonth = ''
            this.claimDateYear = ''
            this.noIndividualSessions = null
            this.noGroupSessions = null
            this.noRemoteSessions = null
            this.noPhoneSessions = null
            this.noVideoSessions = null
            this.noAssessmentSessions = null
            this.noCoupleSessions = null
            this.noFamilySessions = null
            this.clientInsurance = ''
            this.isInsuranceUtilizedForClaim = ''
            // isInsuranceUtilizedForClaim: YES
            this.insuranceReimbursementRateForIndividualSessions = null
            this.insuranceReimbursementRateForGroupSessions = null
            this.insuranceReimbursementRateForRemoteSessions = null
            // isInsuranceUtilizedForClaim: No
            this.ifNotUtilizingInsurance = ''
            // ifNotUtilizingInsurance: Other
            this.ifNotUtilizingInsuranceResponseOther = ''
            this.clientProgressThisMonth = ''
            this.clientReportsSatisfactionWithTreatmentSessions = ''
            // clientReportsSatisfactionWithTreatmentSessions: No
            this.ifNoReportsSatisfaction = ''
            this.didClientProvideCopay = ''
            this.copayAmount = ''
            this.didClientUtilizeSlidingScale = ''
            this.amount = ''
            this.amountBilledToCFE = '$0.00'
            this.notes = ''
            this.client = ''
            this.dateOfBirthPGRCOASASProgram = ''
            this.sexAtBirth = ''
            this.last4SSN = ''
            this.firstTwoLettersLastName = ''
            this.itemsFormRepeater = []
        },
        validationForm() {
            this.$refs.editClinicianRules.validate().then(success => {
                if(success) {
                    this.validFormRepeater = true
                    var validateFormRepeater = true
                    this.itemsFormRepeater.forEach(ele => {
                        // ele.valid = true
                        // id: this.nextTodoId += this.itemsFormRepeater.length,
                        // dayOfSession: '',1
                        // typeOfSession: '',2
                        // lengthOfSession: '',3
                        // howConducted: '',4
                        // remoteOption: '',5
                        // isInsuranceUtilizedForSession: '',6
                        // nameOfInsuranceCompany: '',7
                        // enterAmmountInsuranceCompanyPay: null,8
                        // ifNotUtilizingInsuranceSession: '',14
                        // ifNotUtilizingInsuranceSessionResponseOther: '',15
                        // didClientProvideCopay: '',9
                        // copayAmount: '',10
                        // didClientUtilizeSlidingScale: '',11
                        // amount: '',12

                        if(!ele.dayOfSession || !ele.typeOfSession || !ele.lengthOfSession || !ele.howConducted || !ele.isInsuranceUtilizedForSession || !ele.didClientUtilizeSlidingScale) {
                            validateFormRepeater = false
                        }

                        if(ele.howConducted === 'Remote' && !ele.remoteOption) {
                            validateFormRepeater = false
                        }

                        // if(ele.isInsuranceUtilizedForSession === 'Yes') {
                        //     if(!ele.didClientProvideCopay) {
                        //         validateFormRepeater = false
                        //     }
                        // }

                        if(ele.isInsuranceUtilizedForSession === 'Yes' && (!ele.nameOfInsuranceCompany || ele.enterAmmountInsuranceCompanyPay === '')) {
                            // validateFormRepeater = false
                        } else if(ele.isInsuranceUtilizedForSession === 'No') {
                            // if(!ele.ifNotUtilizingInsuranceSession) {
                            //     validateFormRepeater = false
                            // } else if(ele.ifNotUtilizingInsuranceSession === 'Other') {
                            //     if(!ele.ifNotUtilizingInsuranceSessionResponseOther) {
                            //         validateFormRepeater = false
                            //     }
                            // }
                        }

                        // if(ele.didClientProvideCopay === 'Yes') {
                        //     if(ele.copayAmount === '') {
                        //         validateFormRepeater = false
                        //     }
                        // }

                        if(ele.didClientUtilizeSlidingScale === 'Yes') {
                            if(ele.amount === '') {
                                validateFormRepeater = false
                            }
                        }

                        // subtotalBilledToPGRC: '$0.00', 13
                        // isClientProvidingPaymentForSession: '',
                        // enterAmountClientPaysForSession: '',
                    })
                    // console.log(validateFormRepeater)

                    // eslint-disable-next-line
                    if(validateFormRepeater) {
                        this.submitFormClientClaim()
                        // console.log('submit')
                    } else {
                        this.validFormRepeater = false
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `(*) One or more required field(s) are missing.`,
                                icon: 'CoffeeIcon',
                                variant: 'danger',
                            },
                        })
                    }
                } else {
                    this.validFormRepeater = true
                    var validateFormRepeater = true
                    this.itemsFormRepeater.forEach(ele => {
                        if(!ele.dayOfSession || !ele.typeOfSession || !ele.lengthOfSession || !ele.howConducted || !ele.isInsuranceUtilizedForSession || !ele.didClientUtilizeSlidingScale) {
                            validateFormRepeater = false
                        }

                        if(ele.howConducted === 'Remote' && !ele.remoteOption) {
                            validateFormRepeater = false
                        }

                        // if(ele.isInsuranceUtilizedForSession === 'Yes') {
                        //     if(!ele.didClientProvideCopay) {
                        //         validateFormRepeater = false
                        //     }
                        // }

                        if(ele.isInsuranceUtilizedForSession === 'Yes' && (!ele.nameOfInsuranceCompany || ele.enterAmmountInsuranceCompanyPay === '')) {
                            // validateFormRepeater = false
                        } else if(ele.isInsuranceUtilizedForSession === 'No') {
                            // if(!ele.ifNotUtilizingInsuranceSession) {
                            //     validateFormRepeater = false
                            // } else if(ele.ifNotUtilizingInsuranceSession === 'Other') {
                            //     if(!ele.ifNotUtilizingInsuranceSessionResponseOther) {
                            //         validateFormRepeater = false
                            //     }
                            // }
                        }

                        // if(ele.didClientProvideCopay === 'Yes') {
                        //     if(ele.copayAmount === '') {
                        //         validateFormRepeater = false
                        //     }
                        // }

                        if(ele.didClientUtilizeSlidingScale === 'Yes') {
                            if(ele.amount === '') {
                                validateFormRepeater = false
                            }
                        }
                    })

                    if(!validateFormRepeater) {
                        this.validFormRepeater = false
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `(*) One or more required field(s) are missing.`,
                                icon: 'CoffeeIcon',
                                variant: 'danger',
                            },
                        })
                    }
                }
            })
        },
        validationFormRemoteSesions(bvModalEvt) {
            bvModalEvt.preventDefault()
            this.$refs.editRemoteSesionsRules.validate().then(success => {
                if (success) {
                    // this.submitFormClientClaim()
                    // noRemoteSessions: null,
                    // noPhoneSessions: null,
                    // noVideoSessions: null,
                    var noRemoteSessionsAtomic =  parseInt(this.noRemoteSessions, 10)
                    var noPhoneSessionsAtomic =  parseInt(this.noPhoneSessions, 10)
                    var noVideoSessionsAtomic =  parseInt(this.noVideoSessions, 10)

                    var sumRemoteSessions = noPhoneSessionsAtomic + noVideoSessionsAtomic
                    
                    if (noRemoteSessionsAtomic === sumRemoteSessions) {
                        this.msgRemoteSessions = ''
                        this.$refs['modal-RemoteSessions'].hide()
                    } else if(noRemoteSessionsAtomic < sumRemoteSessions) {
                        this.msgRemoteSessions = '# of Remote sessions cannot be less than the sum of # of Phone Sessions and # of Video Sessions'
                    } else if(noRemoteSessionsAtomic > sumRemoteSessions) {
                        this.msgRemoteSessions = 'Remote sessions cannot be higher than the sum of # of Phone Sessions and # of Video Sessions'
                    }
                }
            })
        },
        onRowSelected(items) {
            this.idClientClaim = items.id
            this.statusEdit = true
            // console.log(this.idClientActivity)
        },
        // repeaterForm sessions
        repeateAgain() {
            this.itemsFormRepeater.push({
                id: this.nextTodoId += this.itemsFormRepeater.length,
                dayOfSession: '',
                typeOfSession: '',
                lengthOfSession: '',
                howConducted: '',
                remoteOption: '',
                isInsuranceUtilizedForSession: '',
                nameOfInsuranceCompany: '',
                enterAmmountInsuranceCompanyPay: null,
                // isInsuranceUtilizedForSession: '',
                ifNotUtilizingInsuranceSession: '',
                ifNotUtilizingInsuranceSessionResponseOther: '',
                isClientProvidingPaymentForSession: '',
                enterAmountClientPaysForSession: '',
                didClientProvideCopay: '',
                copayAmount: '',
                didClientUtilizeSlidingScale: '',
                amount: '',
                subtotalBilledToPGRC: '$0.00',
            })

            this.$nextTick(() => {
                this.trAddHeight(this.$refs.row[0].offsetHeight)
            })
        },
        removeItem(index) {
            this.itemsFormRepeater.splice(index, 1)
            this.counterSession()
            this.trTrimHeight(this.$refs.row[0].offsetHeight)
        },
        initTrHeight() {
            this.trSetHeight(null)
            // this.$nextTick(() => {
            //     this.trSetHeight(this.$refs.formRepeaterSessions.scrollHeight)
            // })
        },
    },
    created() {
        this.searchClaimUserName('')
        this.searchClaimUserStatus('')
        this.programClinician = ''
        window.addEventListener('resize', this.initTrHeight)

        const user = auth.currentUser
        db.collection('usuarios').doc(user.uid).get()
        .then(userDoc => {
            this.userLoggedData = {}
            this.userLoggedData = {
                firstName: userDoc.data().firstName ? userDoc.data().firstName : '',
                lastName: userDoc.data().lastName ? userDoc.data().lastName : '',
                email: userDoc.data().email ? userDoc.data().email : '',
                uid: userDoc.data().uid ? userDoc.data().uid : '',
                id: userDoc.id
            }

            if(userDoc.data().role === 'admin') {
                this.adminOrManageUsers = true
                this.isAdmin = true
            } else if(userDoc.data().role === 'staff') {
                if(userDoc.data().permissions.includes('manage users') || userDoc.data().permissions.includes('program manager - vse')) {
                    this.adminOrManageUsers = true
                } else if(userDoc.data().permissions.includes('data specialist')) {
                    this.dataSpecialist = true
                } else if(userDoc.data().permissions.includes('clinician viewer')) {
                    this.clinicianOrClinicianViewer = true
                } else {
                    this.clinicianOrClinicianViewer = true
                }
            } else if(userDoc.data().role === 'clinician') {
                this.isClinician = true
            }

            if(userDoc.data().role === 'clinician-staff') {
                // var idOwnerClinician = userDoc.data().dependency
                var TrueidClinicianDependency = userDoc.data().dependency
                db.collection('usuarios').doc(TrueidClinicianDependency)
                .onSnapshot(userDoc => {
                    if(userDoc.exists) {
                        this.programClinician = userDoc.data().program ? userDoc.data().program : ''

                        if(userDoc.data().region.toLowerCase() === 'nyc' || userDoc.data().region.toLowerCase() === 'bronx' || userDoc.data().region.toLowerCase() === 'brooklyn' || userDoc.data().region.toLowerCase() === 'manhattan' || userDoc.data().region.toLowerCase() === 'queens' || userDoc.data().region.toLowerCase() === 'staten island') {
                            this.ammountRegionCalculated1 = 90
                        } else {
                            this.ammountRegionCalculated1 = 45
                        }

                        if(userDoc.data().region.toLowerCase() === 'northeast' || userDoc.data().region.toLowerCase() === 'central' || userDoc.data().region.toLowerCase() === 'finger lakes' || userDoc.data().region.toLowerCase() === 'western') {
                            this.ammountRegionCalculated2 = 80
                        } else {
                            this.ammountRegionCalculated2 = 40
                        }

                        if(userDoc.data().region.toLowerCase() === 'mid-hudson' || userDoc.data().region.toLowerCase() === 'long island' || userDoc.data().region.toLowerCase() === 'nyc' || userDoc.data().region.toLowerCase() === 'bronx' || userDoc.data().region.toLowerCase() === 'brooklyn' || userDoc.data().region.toLowerCase() === 'manhattan' || userDoc.data().region.toLowerCase() === 'queens' || userDoc.data().region.toLowerCase() === 'staten island') {
                            // this.individual45Min = 140
                            // this.individual90Min = 280
                            // this.group45Min = 70
                            // this.group90Min = 140
                            this.individual15Min = 47
                            this.individual30Min = 94
                            this.individual45Min = 140
                            this.individual60Min = 187
                            this.individual75Min = 234
                            this.individual90Min = 280
                            this.group15Min = 23.5
                            this.group30Min = 47
                            this.group45Min = 70
                            this.group60Min = 93.5
                            this.group75Min = 117
                            this.group90Min = 140
                        }
                        if(userDoc.data().region.toLowerCase() === 'northeast' || userDoc.data().region.toLowerCase() === 'central' || userDoc.data().region.toLowerCase() === 'finger lakes' || userDoc.data().region.toLowerCase() === 'western') {
                            // this.individual45Min = 120
                            // this.individual90Min = 240
                            // this.group45Min = 60
                            // this.group90Min = 120
                            this.individual15Min = 40
                            this.individual30Min = 80
                            this.individual45Min = 120
                            this.individual60Min = 160
                            this.individual75Min = 200
                            this.individual90Min = 240
                            this.group15Min = 20
                            this.group30Min = 40
                            this.group45Min = 60
                            this.group60Min = 80
                            this.group75Min = 100
                            this.group90Min = 120
                        }
                    }
                })

                var idOwnerClinician = user.uid
                this.idClinicianDependency = user.uid
                db.collection('usuarios').doc(idOwnerClinician)
                .onSnapshot(userDoc => {
                    if(userDoc.exists) {
                        // this.programClinician = userDoc.data().program ? userDoc.data().program : ''
                        this.isBusy = true

                        setTimeout(() => {
                            // this.$http.get(`https://us-central1-nycpg-67e48.cloudfunctions.net/app/api/prod/clinicians/claims/${idOwnerClinician}`)
                            this.$http.get(`https://us-central1-nycpg-67e48.cloudfunctions.net/app/api/prod/clinicians/claims-staff/${idOwnerClinician}/${TrueidClinicianDependency}`)
                            .then(res => {
                                this.isBusy = false
                                // console.log(res.data)
                                this.setSnapshotClaimsUser(res.data)
                            })
                        }, 1000)
                    }
                })

                db.collection('usuarios').doc(idOwnerClinician).get()
                .then(userDoc => {
                    this.userData = {}
                    this.userData = {
                        codigo: userDoc.data().codigo ? userDoc.data().codigo : '',
                        firstName: userDoc.data().firstName ? userDoc.data().firstName : '',
                        lastName: userDoc.data().lastName ? userDoc.data().lastName : '',
                        agency: userDoc.data().agency ? userDoc.data().agency : '',
                        region: userDoc.data().region ? userDoc.data().region : '',
                        borough: userDoc.data().borough ? userDoc.data().borough : '',
                        statusReferral: userDoc.data().statusReferral ? userDoc.data().statusReferral : '',
                        program: userDoc.data().program ? userDoc.data().program : '',
                        email: userDoc.data().email ? userDoc.data().email : '',
                        uid: userDoc.data().uid ? userDoc.data().uid : '',
                        id: userDoc.id
                    }
                    
                    // if(userDoc.data().region.toLowerCase() === 'nyc' || userDoc.data().region.toLowerCase() === 'bronx' || userDoc.data().region.toLowerCase() === 'brooklyn' || userDoc.data().region.toLowerCase() === 'manhattan' || userDoc.data().region.toLowerCase() === 'queens' || userDoc.data().region.toLowerCase() === 'staten island') {
                    //     this.ammountRegionCalculated1 = 90
                    // } else {
                    //     this.ammountRegionCalculated1 = 45
                    // }

                    // if(userDoc.data().region.toLowerCase() === 'northeast' || userDoc.data().region.toLowerCase() === 'central' || userDoc.data().region.toLowerCase() === 'finger lakes' || userDoc.data().region.toLowerCase() === 'western') {
                    //     this.ammountRegionCalculated2 = 80
                    // } else {
                    //     this.ammountRegionCalculated2 = 40
                    // }

                    // if(userDoc.data().region.toLowerCase() === 'mid-hudson' || userDoc.data().region.toLowerCase() === 'long island' || userDoc.data().region.toLowerCase() === 'nyc' || userDoc.data().region.toLowerCase() === 'bronx' || userDoc.data().region.toLowerCase() === 'brooklyn' || userDoc.data().region.toLowerCase() === 'manhattan' || userDoc.data().region.toLowerCase() === 'queens' || userDoc.data().region.toLowerCase() === 'staten island') {
                    //     // this.individual45Min = 140
                    //     // this.individual90Min = 280
                    //     // this.group45Min = 70
                    //     // this.group90Min = 140
                    //     this.individual15Min = 47
                    //     this.individual30Min = 94
                    //     this.individual45Min = 140
                    //     this.individual60Min = 187
                    //     this.individual75Min = 234
                    //     this.individual90Min = 280
                    //     this.group15Min = 23.5
                    //     this.group30Min = 47
                    //     this.group45Min = 70
                    //     this.group60Min = 93.5
                    //     this.group75Min = 117
                    //     this.group90Min = 140
                    // }
                    // if(userDoc.data().region.toLowerCase() === 'northeast' || userDoc.data().region.toLowerCase() === 'central' || userDoc.data().region.toLowerCase() === 'finger lakes' || userDoc.data().region.toLowerCase() === 'western') {
                    //     // this.individual45Min = 120
                    //     // this.individual90Min = 240
                    //     // this.group45Min = 60
                    //     // this.group90Min = 120
                    //     this.individual15Min = 40
                    //     this.individual30Min = 80
                    //     this.individual45Min = 120
                    //     this.individual60Min = 160
                    //     this.individual75Min = 200
                    //     this.individual90Min = 240
                    //     this.group15Min = 20
                    //     this.group30Min = 40
                    //     this.group45Min = 60
                    //     this.group60Min = 80
                    //     this.group75Min = 100
                    //     this.group90Min = 120
                    // }
                })

                db.collection('clientsActivity').where('clinician', 'array-contains', idOwnerClinician).get()
                .then(engaged => {
                    this.optionsClient = []
                    engaged.forEach(clients => {
                        db.collection('clients').doc(clients.data().client).get()
                        .then(dataClinician => {
                            if(dataClinician.data().status === 'active') {
                                if(this.optionsClient.length >= 1) {
                                    var findDuplicateClient = this.optionsClient.find(item => item.id === dataClinician.id);
                                    if(!findDuplicateClient) {
                                        var codigo = dataClinician.data().id ? ' (#' + dataClinician.data().id + ')' : ''
                                        var obj = dataClinician.data()
                                        obj.label = dataClinician.data().firstName + ' ' + dataClinician.data().lastName + codigo
                                        obj.clientID = dataClinician.data().id
                                        obj.dateOfBirth = dataClinician.data().dateOfBirth ? dataClinician.data().dateOfBirth : ''
                                        obj.firstTwoLettersLastName = dataClinician.data().firstTwoLettersLastName ? dataClinician.data().firstTwoLettersLastName : ''
                                        obj.last4ofSSN = dataClinician.data().last4ofSSN ? dataClinician.data().last4ofSSN : ''
                                        obj.sexAtBirth = dataClinician.data().sexAtBirth ? dataClinician.data().sexAtBirth : ''
                                        obj.id = dataClinician.id
                                        this.optionsClient.push(obj)
                                    }
                                } else {
                                    var codigo = dataClinician.data().id ? ' (#' + dataClinician.data().id + ')' : ''
                                    var obj = dataClinician.data()
                                    obj.label = dataClinician.data().firstName + ' ' + dataClinician.data().lastName + codigo
                                    obj.clientID = dataClinician.data().id
                                    obj.dateOfBirth = dataClinician.data().dateOfBirth ? dataClinician.data().dateOfBirth : ''
                                    obj.firstTwoLettersLastName = dataClinician.data().firstTwoLettersLastName ? dataClinician.data().firstTwoLettersLastName : ''
                                    obj.last4ofSSN = dataClinician.data().last4ofSSN ? dataClinician.data().last4ofSSN : ''
                                    obj.sexAtBirth = dataClinician.data().sexAtBirth ? dataClinician.data().sexAtBirth : ''
                                    obj.id = dataClinician.id
                                    this.optionsClient.push(obj)
                                }
                            }
                        })
                    })
                })
            } else {
                this.idClinicianDependency = this.$route.params.id
                db.collection('usuarios').doc(this.$route.params.id)
                .onSnapshot(userDoc => {
                    if(userDoc.exists) {
                        this.programClinician = userDoc.data().program ? userDoc.data().program : ''
                        this.isBusy = true

                        setTimeout(() => {
                            this.$http.get(`https://us-central1-nycpg-67e48.cloudfunctions.net/app/api/prod/clinicians/claims/${this.$route.params.id}`)
                            .then(res => {
                                this.isBusy = false
                                // console.log(res.data)
                                this.setSnapshotClaimsUser(res.data)
                            })
                        }, 1000)
                    }
                })

                db.collection('usuarios').doc(this.$route.params.id).get()
                .then(userDoc => {
                    this.userData = {}
                    this.userData = {
                        codigo: userDoc.data().codigo ? userDoc.data().codigo : '',
                        firstName: userDoc.data().firstName ? userDoc.data().firstName : '',
                        lastName: userDoc.data().lastName ? userDoc.data().lastName : '',
                        agency: userDoc.data().agency ? userDoc.data().agency : '',
                        region: userDoc.data().region ? userDoc.data().region : '',
                        borough: userDoc.data().borough ? userDoc.data().borough : '',
                        statusReferral: userDoc.data().statusReferral ? userDoc.data().statusReferral : '',
                        program: userDoc.data().program ? userDoc.data().program : '',
                        email: userDoc.data().email ? userDoc.data().email : '',
                        uid: userDoc.data().uid ? userDoc.data().uid : '',
                        id: userDoc.id
                    }
                    
                    if(userDoc.data().region.toLowerCase() === 'nyc' || userDoc.data().region.toLowerCase() === 'bronx' || userDoc.data().region.toLowerCase() === 'brooklyn' || userDoc.data().region.toLowerCase() === 'manhattan' || userDoc.data().region.toLowerCase() === 'queens' || userDoc.data().region.toLowerCase() === 'staten island') {
                        this.ammountRegionCalculated1 = 90
                    } else {
                        this.ammountRegionCalculated1 = 45
                    }

                    if(userDoc.data().region.toLowerCase() === 'northeast' || userDoc.data().region.toLowerCase() === 'central' || userDoc.data().region.toLowerCase() === 'finger lakes' || userDoc.data().region.toLowerCase() === 'western') {
                        this.ammountRegionCalculated2 = 80
                    } else {
                        this.ammountRegionCalculated2 = 40
                    }

                    if(userDoc.data().region.toLowerCase() === 'mid-hudson' || userDoc.data().region.toLowerCase() === 'long island' || userDoc.data().region.toLowerCase() === 'nyc' || userDoc.data().region.toLowerCase() === 'bronx' || userDoc.data().region.toLowerCase() === 'brooklyn' || userDoc.data().region.toLowerCase() === 'manhattan' || userDoc.data().region.toLowerCase() === 'queens' || userDoc.data().region.toLowerCase() === 'staten island') {
                        // this.individual45Min = 140
                        // this.individual90Min = 280
                        // this.group45Min = 70
                        // this.group90Min = 140
                        this.individual15Min = 47
                        this.individual30Min = 94
                        this.individual45Min = 140
                        this.individual60Min = 187
                        this.individual75Min = 234
                        this.individual90Min = 280
                        this.group15Min = 23.5
                        this.group30Min = 47
                        this.group45Min = 70
                        this.group60Min = 93.5
                        this.group75Min = 117
                        this.group90Min = 140
                    }
                    if(userDoc.data().region.toLowerCase() === 'northeast' || userDoc.data().region.toLowerCase() === 'central' || userDoc.data().region.toLowerCase() === 'finger lakes' || userDoc.data().region.toLowerCase() === 'western') {
                        // this.individual45Min = 120
                        // this.individual90Min = 240
                        // this.group45Min = 60
                        // this.group90Min = 120
                        this.individual15Min = 40
                        this.individual30Min = 80
                        this.individual45Min = 120
                        this.individual60Min = 160
                        this.individual75Min = 200
                        this.individual90Min = 240
                        this.group15Min = 20
                        this.group30Min = 40
                        this.group45Min = 60
                        this.group60Min = 80
                        this.group75Min = 100
                        this.group90Min = 120
                    }
                })

                db.collection('clientsActivity').where('clinician', 'array-contains', this.$route.params.id).get()
                .then(engaged => {
                    this.optionsClient = []
                    engaged.forEach(clients => {
                        db.collection('clients').doc(clients.data().client).get()
                        .then(dataClinician => {
                            if(dataClinician.data().status === 'active') {
                                if(this.optionsClient.length >= 1) {
                                    var findDuplicateClient = this.optionsClient.find(item => item.id === dataClinician.id);
                                    if(!findDuplicateClient) {
                                        var codigo = dataClinician.data().id ? ' (#' + dataClinician.data().id + ')' : ''
                                        var obj = dataClinician.data()
                                        obj.label = dataClinician.data().firstName + ' ' + dataClinician.data().lastName + codigo
                                        obj.clientID = dataClinician.data().id
                                        obj.dateOfBirth = dataClinician.data().dateOfBirth ? dataClinician.data().dateOfBirth : ''
                                        obj.firstTwoLettersLastName = dataClinician.data().firstTwoLettersLastName ? dataClinician.data().firstTwoLettersLastName : ''
                                        obj.last4ofSSN = dataClinician.data().last4ofSSN ? dataClinician.data().last4ofSSN : ''
                                        obj.sexAtBirth = dataClinician.data().sexAtBirth ? dataClinician.data().sexAtBirth : ''
                                        obj.id = dataClinician.id
                                        this.optionsClient.push(obj)
                                    }
                                } else {
                                    var codigo = dataClinician.data().id ? ' (#' + dataClinician.data().id + ')' : ''
                                    var obj = dataClinician.data()
                                    obj.label = dataClinician.data().firstName + ' ' + dataClinician.data().lastName + codigo
                                    obj.clientID = dataClinician.data().id
                                    obj.dateOfBirth = dataClinician.data().dateOfBirth ? dataClinician.data().dateOfBirth : ''
                                    obj.firstTwoLettersLastName = dataClinician.data().firstTwoLettersLastName ? dataClinician.data().firstTwoLettersLastName : ''
                                    obj.last4ofSSN = dataClinician.data().last4ofSSN ? dataClinician.data().last4ofSSN : ''
                                    obj.sexAtBirth = dataClinician.data().sexAtBirth ? dataClinician.data().sexAtBirth : ''
                                    obj.id = dataClinician.id
                                    this.optionsClient.push(obj)
                                }
                            }
                        })
                    })
                })
            }
        })

        var year = new Date().getFullYear()
        for(var i = year - 30; i <= year + 10; i++) {
            this.optionsYears.push(i)
        }

        db.collection('taxonomies').doc('client').get()
        .then(docTaxonomia => {
            this.optionsInsuranceType = docTaxonomia.data().insuranceType
        })

        
    },
    mounted() {
        this.initTrHeight()

        if (window.history && window.history.pushState) {
            window.history.pushState('forward', null, '');

            window.addEventListener('popstate', () => {
                // alert('Back button was pressed.');
                this.statusEdit = false
                this.statusCreate = false
                this.$emit('statusEditClinician',false)
            });
        }

        this.$emit('statusEditClinician',true)
    },
    destroyed() {
        window.removeEventListener('resize', this.initTrHeight)
    },
}
</script>

<style>
.vs--disabled .vs__selected {
    color: #656b85 !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>